import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { setToken, setUser } from "../utils";
import type { AuthResponse } from "../../types/linked-accounts";

export function usePropertySwitch() {
  return useMutation({
    mutationFn: async (targetUserId: string): Promise<AuthResponse> => {
      (
        window as unknown as { __SUPPRESS_AUTH_REDIRECT__?: boolean }
      ).__SUPPRESS_AUTH_REDIRECT__ = true;

      const res = await api.switchProperty(targetUserId);
      return res.data as AuthResponse;
    },
    onError: () => {

      (
        window as unknown as { __SUPPRESS_AUTH_REDIRECT__?: boolean }
      ).__SUPPRESS_AUTH_REDIRECT__ = false;
    },
    onSuccess: (auth) => {
      const me = auth.linkedAccounts.find((m) => m.isCurrent);
      setToken(auth.accessToken);
      setUser({
        ...auth,
        firstName: me?.userFirstName,
        lastName: me?.userLastName,
        email: me?.userEmail ?? auth.email,
      });
      window.location.reload();
    },
  });
}

export function pickAutoSwitchTarget(
  auth: AuthResponse,
): { userId: string } | null {
  if (!auth.linkedAccounts || auth.linkedAccounts.length < 2) return null;
  if (!auth.lastUsedHotelId) return null;
  if (auth.lastUsedHotelId === auth.currentHotel.id) return null;

  const target = auth.linkedAccounts.find(
    (m) => m.hotelId === auth.lastUsedHotelId,
  );
  if (!target || target.isCurrent) return null;
  return { userId: target.userId };
}
